/*
 * SHOP NOW fix for the legacy Replo "solution" pages (/pages/collection-page-*).
 *
 * Those pages render SHOP NOW as Replo add-to-cart buttons with no href, so
 * high-intent visitors get a cart drawer instead of the product page and never
 * see details, evidence, or reviews (Clarity: one shopper spent 30 steps here
 * without reaching a PDP). This intercepts SHOP NOW clicks at capture phase
 * and navigates to the matching PDP instead. Card text -> handle mapping,
 * most specific pattern first; unknown cards fall back to the shop-all
 * collection rather than a dead end.
 */
(function () {
  var MAP = [
    [/decorative bright[\s\S]*flashcard/i, '/products/decorative-brights-phonics-flashcards'],
    [/decorative bright[\s\S]*replacement/i, '/products/decorative-brights-replacement-posters'],
    [/decorative bright/i, '/products/decorative-brights-class-kit'],
    [/cool pastel[\s\S]*flashcard/i, '/products/cool-pastel-flashcards'],
    [/cool pastel[\s\S]*replacement/i, '/products/cool-pastels-replacement-posters'],
    [/cool pastel/i, '/products/cool-pastels-class-kit'],
    [/warm neutral[\s\S]*flashcard/i, '/products/warm-neutrals-phonics-flashcards'],
    [/warm neutral[\s\S]*replacement/i, '/products/warm-neutrals-replacement-posters'],
    [/warm neutral/i, '/products/warm-neutrals-class-kit'],
    [/tropical sunset[\s\S]*flashcard/i, '/products/tropical-sunset-flashcards'],
    [/tropical sunset/i, '/products/tropical-sunset-class-kit'],
    [/space saver/i, '/products/space-saver-square-classroom-kit'],
    [/original red|red[\s\S]*flashcard|brain.based/i, '/products/brain-based-red-phonics-flashcards'],
    [/workbook/i, '/products/workbook-level-1'],
    [/professional development[\s\S]*individual/i, '/products/professional-development-individual'],
    [/professional development/i, '/products/professional-development'],
    // "parents" appears in every card's trust line, so match the bundle only
    // on its distinctive words.
    [/homeschool/i, '/products/parent-homeschool-resource-bundle'],
    [/better alphabet/i, '/products/better-alphabet-cards'],
    [/phonics app|app[\s\S]*subscription/i, '/products/the-secret-stories-app-monthly-subscription'],
  ];

  function targetFor(btn) {
    var el = btn.parentElement;
    var card = null;
    for (var d = 0; d < 10 && el; d++) {
      if (el.querySelector('img')) { card = el; break; }
      el = el.parentElement;
    }
    var text = (card ? card.textContent : btn.textContent) || '';
    for (var i = 0; i < MAP.length; i++) {
      if (MAP[i][0].test(text)) return MAP[i][1];
    }
    return '/collections/shop-all';
  }

  // The Replo runtime wins the click-event war on these buttons (the click
  // never reliably reaches other handlers), so navigation happens on
  // POINTERUP, which cannot be suppressed by canceling pointerdown. A
  // press-tracking guard keeps scroll-drags from triggering navigation.
  // window capture fires before document capture, beating Replo regardless
  // of registration order.
  function matchBtn(e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return null;
    var btn = t.closest('button[data-replo-add-product-variant-to-cart], [data-replo-add-product-variant-to-cart]');
    if (!btn) return null;
    if (!/shop\s*now/i.test((btn.textContent || '').trim())) return null;
    return btn;
  }

  var press = null;

  window.addEventListener('pointerdown', function (e) {
    var btn = matchBtn(e);
    if (!btn) { press = null; return; }
    press = { btn: btn, x: e.clientX, y: e.clientY, t: Date.now() };
    e.stopImmediatePropagation();
    e.stopPropagation();
  }, true);

  window.addEventListener('pointerup', function (e) {
    var btn = matchBtn(e);
    if (!btn) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    var ok = press && press.btn === btn &&
      Math.abs(e.clientX - press.x) < 12 && Math.abs(e.clientY - press.y) < 12 &&
      Date.now() - press.t < 1200;
    press = null;
    if (ok) window.location.assign(targetFor(btn));
  }, true);

  // Belt and braces for keyboard activation and browsers that only send click.
  window.addEventListener('click', function (e) {
    var btn = matchBtn(e);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    window.location.assign(targetFor(btn));
  }, true);
})();
;
